import { Link, useLocation, useNavigate, Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useApp } from "@/context/AppContext";
import { CreditCard, FileText, Undo2, BarChart3, LogOut, User as UserIcon, ScanLine, UserCircle } from "lucide-react";

const NAV = [
  { to: "/arka", label: "Arka / Shitja", icon: ScanLine, exact: true },
  { to: "/arka/fatura", label: "Faturat", icon: FileText },
  { to: "/arka/kthime", label: "Kthime", icon: Undo2 },
  { to: "/arka/raport", label: "Raport ditor", icon: BarChart3 },
  { to: "/arka/profili", label: "Profili im", icon: UserCircle },
];

export default function PosLayout() {
  const { user, logout } = useApp();
  const loc = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    if (!user) { nav("/arka/login", { replace: true }); return; }
    if (user.role !== "worker" && user.role !== "admin") nav("/arka/login", { replace: true });
  }, [user, nav]);

  if (!user) return null;

  const isActive = (item) => item.exact ? loc.pathname === item.to : loc.pathname.startsWith(item.to);

  const doLogout = () => { logout(); nav("/arka/login", { replace: true }); };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex flex-col md:flex-row">
      {/* Sidebar */}
      <aside className="md:w-64 md:min-h-screen bg-[#0f0f0f] border-r border-[#262626] flex md:flex-col">
        <div className="p-4 border-b border-[#262626] hidden md:block">
          <img src="/logo-hidrogv.png" alt="HidroGV" className="h-14 w-auto object-contain" />
        </div>
        <div className="md:hidden flex items-center gap-3 p-3 border-b border-[#262626] w-full">
          <img src="/logo-hidrogv.png" alt="HidroGV" className="h-9 w-auto object-contain" />
          <div className="ml-auto flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-[#FFD600] text-black flex items-center justify-center"><UserIcon size={16} /></div>
            <div className="text-xs">
              <div className="font-bold leading-tight">{user.name || "Punëtor"}</div>
              <div className="text-neutral-400 leading-tight capitalize">{user.role === "worker" ? "Punëtor" : "Admin"}</div>
            </div>
          </div>
        </div>

        <nav className="flex md:flex-col overflow-x-auto md:overflow-visible md:flex-1 md:p-3 md:gap-1">
          {NAV.map(item => {
            const Icon = item.icon;
            const active = isActive(item);
            return (
              <Link key={item.to} to={item.to} data-testid={`pos-nav-${item.to.split("/").pop()}`}
                className={`flex-shrink-0 md:flex-shrink flex items-center gap-3 px-4 py-3 text-sm uppercase tracking-wider font-bold transition-colors ${active ? "bg-[#FFD600] text-black" : "text-neutral-300 hover:bg-[#1a1a1a]"}`}>
                <Icon size={16} /> <span className="hidden sm:inline">{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="hidden md:block p-3 border-t border-[#262626]">
          <div className="flex items-center gap-3 p-3 rounded bg-[#1a1a1a] mb-3">
            <div className="w-10 h-10 rounded-full bg-[#FFD600] text-black flex items-center justify-center"><UserIcon size={18} /></div>
            <div className="min-w-0 flex-1">
              <div className="font-bold text-sm truncate" data-testid="pos-user-name">{user.name || "Punëtor"}</div>
              <div className="text-xs text-neutral-400 capitalize">{user.role === "worker" ? "Punëtor" : "Admin"}</div>
            </div>
          </div>
          <button onClick={doLogout} data-testid="pos-logout"
            className="w-full flex items-center justify-center gap-2 px-4 py-3 text-xs uppercase tracking-widest font-bold border border-[#262626] hover:border-red-500 hover:text-red-400">
            <LogOut size={14} /> Dalja
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
